CheckoutV2.PaymentV2.ModalSplitPayment = function(checkout) {
    var splitPaymentModal = this;

    this.$modal = $('#splitPaymentModal');

    // Inputs for the add new card section of the modal
    this.$inputCardNumber = this.$modal.find('input[name="cardnumber"]');
    this.$inputExpirationMonth = this.$modal.find('input[name="expireMonth"]');
    this.$inputExpirationYear = this.$modal.find('input[name="expireYear"]');
    this.$inputCardCVV = this.$modal.find('input[name="cvv"]');

    this.isAddingCard = false;
    this.newCard = null;

    this.cardSelectedCallback = function() {};
    this.modalHiddenCallback = function() {};

    this._init = function() {
        splitPaymentModal._listen();

        // The cvv what is this popover is rendered on page load by the server.
        // Enable it on init since it already exists.
        splitPaymentModal.$modal.find('.js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
            html: true,
            trigger: 'focus',
            placement: 'right',
            boundary: 'window',
            offset: "-40",
            title: '',
            container: splitPaymentModal.$modal.find('.what-is-this')[0]
        });
    };

    this._listen = function() {
        // Button to submit the cc info
        splitPaymentModal.$modal.find('.js-split-btn').on('click', function(e){

            if(splitPaymentModal.isAddingCard) {
                checkout.payment.loading( "Verifying Payment Data" );
                splitPaymentModal.newCard.clearFieldErrors();

                splitPaymentModal._getNewCardData( function( cardData ) {
                    checkout.payment.loading( false );

                    if ( cardData.nonce ) {
                        if ( cardData.hostedFieldsInterface ) {
                            cardData.hostedFieldsInterface.teardown();
                            cardData.hostedFieldsInterface = null;
                        }
                        checkout.payment.addNewCard(cardData);
                        splitPaymentModal.cardSelectedCallback(cardData);
                        splitPaymentModal.$modal.modal('hide');
                    }
                    else {
                        splitPaymentModal.newCard.showFieldErrors( cardData );
                    }
                } );
            } else {
                var $item = splitPaymentModal.$modal.find('.js-has-stored-credit-cards input[type=radio]:checked');
                splitPaymentModal.cardSelectedCallback(splitPaymentModal._getCardById($item.val()));
                splitPaymentModal.$modal.modal('hide');
            }
        });

        // Button to navigate back to the stored payments options
        splitPaymentModal.$modal.find('.js-show-stored-credit-cards').on('click', function(e) {
            e.preventDefault();
            // We're going back to stored cards so flip flags accordingly
            splitPaymentModal.isAddingCard = false;

            splitPaymentModal.$modal.find('.js-split-btn').text('Use This Card');
            splitPaymentModal.$modal.find('.js-has-stored-credit-cards').show();
            splitPaymentModal.$modal.find('.js-no-stored-credit-cards').hide();
        });

        splitPaymentModal.$modal.on('hidden.bs.modal', function(e){
            splitPaymentModal.modalHiddenCallback();
        });
    };

    this.setCardSelectedCallback = function(callback) {
        splitPaymentModal.cardSelectedCallback = callback;
    };

    this.setModalHiddenCallback = function(callback) {
        splitPaymentModal.modalHiddenCallback = callback;
    };

    this.renderStoredCards = function(cards) {
        // Set flag for submit so we know this is a stored card
        splitPaymentModal.isAddingCard = false;

        splitPaymentModal.$modal.find('.js-credit-card-list').html(
            Jemplate.process('includes/partials/payment/creditCardList.html', {
                current_card: cards[0].id,
                card_list: cards,
                list_type: 'split'
            })
        );

        // Update the submit button text, trigger popovers, show the modal
        splitPaymentModal.$modal.find('.js-split-btn').text('Use This Card');
        splitPaymentModal.$modal.find('.js-credit-card-list .card-address[data-toggle="popover"]').popover();
        splitPaymentModal.$modal.find('.js-has-stored-credit-cards').show();
        splitPaymentModal.$modal.find('.js-no-stored-credit-cards').hide();
        splitPaymentModal.$modal.find('.js-show-stored-credit-cards').show();
        splitPaymentModal.$modal.modal('show');

        // Add card link is dynamically added with the render, so the listener needs to be here.
        splitPaymentModal.$modal.find('.js-add-credit-card').on('click', function(e) {
            e.preventDefault();
            splitPaymentModal._clearNewCardForm();
            splitPaymentModal.isAddingCard = true;
            splitPaymentModal.$modal.find('.js-split-btn').text('Add Card');
            splitPaymentModal.$modal.find('.js-has-stored-credit-cards').hide();
            splitPaymentModal.$modal.find('.js-no-stored-credit-cards').show();
        });
    };

    this.renderNewCard = function() {
        // Set flag for submit so we know this is a new card
        splitPaymentModal.isAddingCard = true;

        splitPaymentModal.$modal.find('.js-credit-card-list').html(
            Jemplate.process('includes/partials/payment/creditCardList.html', {
                current_card: null,
                card_list: [],
                list_type: 'split'
            })
        );

        splitPaymentModal._clearNewCardForm();

        // Update the submit button text, trigger popovers, show the modal
        splitPaymentModal.$modal.find('.js-split-btn').text('Use This Card');
        splitPaymentModal.$modal.find('.js-credit-card-list .card-address[data-toggle="popover"]').popover();
        splitPaymentModal.$modal.find('.js-has-stored-credit-cards').hide();
        splitPaymentModal.$modal.find('.js-no-stored-credit-cards').show();
        splitPaymentModal.$modal.find('.js-show-stored-credit-cards').hide();
        splitPaymentModal.$modal.modal('show');
    };

    this._clearNewCardForm = function() {
        var $newCardContainer = splitPaymentModal.$modal.find( ".js-new-card" );
        splitPaymentModal.newCard = new CheckoutV2.PaymentV2.CreditCard.New(
            checkout,
            $newCardContainer,
            true
        );
    };

    this._getNewCardData = function( callback ) {
        checkout.payment.models.paymentMethodFromNewCard(
            checkout.billinfo.getData().billing,
            0,
            splitPaymentModal.newCard.hostedFieldsInterface,
            callback
        );
    };

    this._getCards = function() {
        var cards = [];

        // Grab stored payments from session
        checkout.session.get('storedPayments').forEach(function(card) {
            var payment = checkout.payment.models.paymentMethodFromStoredCard(card, checkout.cart.totals.values.total);
            cards.push(payment);
        });

        // Also add any cards added through the add card modal
        checkout.payment.getAddedCards().forEach(function(card) {
            cards.push(card);
        });

        return cards;
    };

    this._getCardById = function(id){
        var card = splitPaymentModal._getCards().filter(function(item) {
            return item.id === id;
        });

        return card.length ? card[0] : null;
    };

    this._init();
};
